module.exports = __webpack_public_path__ + "img/IPL-Banner-2026.f66348b6.png";